import { changeQueryString } from '@/utils/url'

export const changePageNumberInQuery = (pageNumber: number) => changeQueryString('pageNumber', pageNumber, true)
